export default __webpack_public_path__ + "static/media/hat.3e19d775.png";